import React, { useEffect, useState } from "react";
import { Row, Col, Alert, Divider, Skeleton, Card } from "antd";
import { Link } from "react-router-dom";
import { gql, useLazyQuery } from "@apollo/client";
import OtherErrors from "@general/otherErrors";
import ProfileMessage from "./messages/profileMessage";
import { useLocation } from "react-router-dom";
import Wallet from "./wallet";
import CardMessage from "./messages/cardMessage";
import FreeDayMessage from "./messages/freeDayMessage";
import UnpaidInvoiceMessage from "./messages/unpaidInvoiceMessage";
import UserEvents from "../services/singleServices/events";
import UserClasses from "../services/singleServices/classes";
import ConsultationMessage from "./messages/consultationMessage";
import BthDayMessage from "./messages/brithdayMessage";

function UserDashboard() {
  const [confirmStatus, setConfirmStatus] = useState(null);
  const [name, setName] = useState(null);
  const [walletBalanceRial, setWalletBalanceRial] = useState(0);
  const [freeDayStatus, setFreeDayStatus] = useState(null);
  const [cardStatus, setCardStatus] = useState(null);
  const [consultationStatus, setConsultationStatus] = useState(null);
  const [bthMessage, setBthMessage] = useState(null);
  const [unpaidInvoicesCount, setUnpaidInvoicesCount] = useState(0);
  const location = useLocation();
  const DASHBOARDDATA = gql`
    query {
      getProfile {
        confirmStatus
        freeDayStatus
        birthdayMessage{
          title
          message
        }
        name
        wallet
      }
      getMyCard {
        cardStatus
      }
      unpaidInvoicesCount: getInvoicesCount(searchInput: { isUnpaid: true })
      getPurchases(paginateInput: {}, searchInput: { isConsultation: true }) {
        product {
          name
        }
        reserve {
          startAt
          endAt
          product {
            name
          }
        }
      }
    }
  `;

  const [getDashboardData, dashboardData] = useLazyQuery(DASHBOARDDATA, {
    fetchPolicy: "no-cache",
    onError(error) {
      console.log("dashboard error: " + error.message);
    },
    onCompleted({ getProfile, getMyCard, getPurchases, unpaidInvoicesCount }) {
      setConfirmStatus(getProfile?.confirmStatus);
      setName(getProfile?.name);
      setWalletBalanceRial(getProfile?.wallet);
      setFreeDayStatus(getProfile?.freeDayStatus);
      setBthMessage(getProfile?.birthdayMessage);
      setCardStatus(getMyCard?.cardStatus);
      setConsultationStatus(getPurchases);
      setUnpaidInvoicesCount(unpaidInvoicesCount || 0);
    },
  });
  useEffect(() => {
    getDashboardData();
  }, [location.pathname]);



  if (dashboardData.loading) {
    return (
      <>
        <Skeleton active round />
        <br />
        <Skeleton active round />
      </>
    );
  }

  if (dashboardData.error) {
    console.warn(dashboardData.error);

    return (
      <>
        <OtherErrors />
      </>
    );
  }

  return (
    <div>
      <Row gutter={20}>
        <Col xs={24} lg={16}>
          <Row>
            <span className="dashboardTitles">
              <Divider
                orientation="right"
                style={{ fontSize: "15px", fontWeight: "bold" }}
              >
                اعلان ها
              </Divider>
            </span>
            <div style={{display: "flex",flexDirection:"column", gap:10, width:"100%"}}>
            {bthMessage && <BthDayMessage birthdayMessage={bthMessage} />}
            {confirmStatus && <FreeDayMessage status={freeDayStatus} />}
            <ProfileMessage name={name} confirmStatus={confirmStatus} />
            {confirmStatus === "SUCCESS" && <CardMessage status={cardStatus} />}
            {unpaidInvoicesCount > 0 && (
              <UnpaidInvoiceMessage count={unpaidInvoicesCount} />
            )}
            {consultationStatus !== null && consultationStatus.length ? (
              <ConsultationMessage statuses={consultationStatus} />
            ) : null}
            </div>
          </Row>
        </Col>
        <Col xs={24} lg={8}>
          {confirmStatus === "SUCCESS" && (
            <Row>
              <span className="dashboardTitles">
                <Divider
                  orientation="right"
                  style={{ fontSize: "15px", fontWeight: "bold" }}
                >
                  کیف پول
                </Divider>
              </span>
              <Wallet balance={walletBalanceRial} />
            </Row>
          )}
        </Col>
      </Row>

    </div>
  );
}

export default UserDashboard;
